import React from 'react';
import { StaticPageLayout } from './StaticPageLayout';
import { PartnerTermsContent } from './PartnerTermsContent';
import { PARTNER_OFFER_UPDATED_AT } from '../../config/legal';

export const TermsPartnersPage: React.FC = () => (
  <StaticPageLayout
    kicker="Правовая информация"
    title="Публичная оферта для партнёров"
    documentTitle="QPrice — Публичная оферта для партнёров"
    updatedAt={PARTNER_OFFER_UPDATED_AT}
  >
    <div className="qp-prose">
      <PartnerTermsContent />
    </div>
  </StaticPageLayout>
);
